import { useState, useEffect } from 'react';
import { transactions, answerOptions } from './data';
import FinancialStatement from '../../../thePrinciples/financialStatement';
import TransactionsDecisions from '../../../thePrinciples/transactionsDecisions';
import { getAnimationClass } from './../utils';

export default function RevenueRecognition({ onComplete, numberOfAttempts }) {
  const [showIntroP, setShowIntroP] = useState(false);
  const [showIncomeStatement, setShowIncomeStatement] = useState(false);
  const [fadeOutFirstSection, setFadeOutFirstSection] = useState(false);
  const [hideFirstSection, setHideFirstSection] = useState(false);
  
  const [showSecondP, setShowSecondP] = useState(false);
  const [showRecognitions, setShowRecognitions] = useState(false);
  const [fadeOutSecondSection, setFadeOutSecondSection] = useState(false);
  const [hideSecondSection, setHideSecondSection] = useState(false);
  
  const [showThirdSectionIntroP, setShowThirdSectionIntroP] = useState(false);
  const [showThirdSectionTransactions, setShowThirdSectionTransactions] = useState(false);
  const [showThirdSectionSecondP, setShowThirdSectionSecondP] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 0;
    
    currentTime += 500;
    timeouts.push(setTimeout(() => setShowIntroP(true), currentTime));
    
    currentTime += 4000;
    timeouts.push(setTimeout(() => setShowIncomeStatement(true), currentTime));
    
    currentTime += 5000;
    timeouts.push(setTimeout(() => {
      setFadeOutFirstSection(true);
      setShowSecondP(true);
    }, currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => setHideFirstSection(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setShowRecognitions(true), currentTime));
    
    currentTime += 6000;
    timeouts.push(setTimeout(() => {
      setFadeOutSecondSection(true);
      setShowThirdSectionIntroP(true);
    }, currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => setHideSecondSection(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setShowThirdSectionTransactions(true), currentTime));
    
    currentTime += 4000;
    timeouts.push(setTimeout(() => {
      setShowThirdSectionIntroP(false);
      setShowThirdSectionSecondP(true);
    }, currentTime));
    
    currentTime += 4000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Principles</h1>
      
      <div className="animation-section">
        {!hideFirstSection && (
          <div className={`animation-content ${fadeOutFirstSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showIntroP, fadeOutFirstSection)}>
              <b>Hot Take!</b> In accrual accounting, cash received or paid doesn't determine a company's profitability, revenues and expenses do.
            </p>
            
            <div className={`transition-income-statement ${getAnimationClass(showIncomeStatement, fadeOutFirstSection)}`}>
              <FinancialStatement 
                title="Income Statement"
                revenues={5000}
                expenses={-1000}
              />
            </div>
          </div>
        )}

        {showSecondP && !hideSecondSection && (
          <div className={`animation-content ${fadeOutSecondSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showSecondP, fadeOutSecondSection)}>
              This exercise will help you master <b>Revenue and Expense Recognition</b>, two core accounting principles that dictate when transactions impact a company's profits.
            </p>
            
            {showRecognitions && (
              <div className={`transition-recognitions ${getAnimationClass(showRecognitions, fadeOutSecondSection)}`}>
                <div className="transition-recognition revenue">
                  <h4>Revenue Recognition Principles</h4>
                  <p>Recognize revenues when "earned"</p>
                </div>
                <div className="transition-recognition expense">
                  <h4>Expense Recognition Principles</h4>
                  <p>Recognize expenses when "incurred"</p>
                </div>
              </div>
            )}
          </div>
        )}

        {(showThirdSectionIntroP || showThirdSectionSecondP) && (
          <div className="animation-content">
            {!showThirdSectionSecondP && (
              <p className={`transition-principles-third-secion-p ${getAnimationClass(showThirdSectionIntroP)}`}>
                You'll begin with the Revenue Recognition Principle by reviewing a series of transactions and deciding whether they affect profits. <b className="red">Pro tip</b>: Revenue affects profits and is recognized when a product is delivered or serviced provided, not necessarily when cash is received.
              </p>
            )}

            {showThirdSectionSecondP && (
              <p className={`transition-principles-third-secion-p ${getAnimationClass(showThirdSectionSecondP)}`}>
                You've got <b>up to {numberOfAttempts} attempts</b>, so no stress. Each try will help you build confidence and clarity.
              </p>
            )}
            
            {showThirdSectionTransactions && (
              <div className={`transition-transactions-decisions ${getAnimationClass(showThirdSectionTransactions)}`}>
                <TransactionsDecisions
                  transactions={transactions}
                  activeTransaction={0}
                  answerOptions={answerOptions}
                  isSubmitButtonShown={true}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}